import React from 'react';
import {BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Land1 from './Landings/Land1';


function App() {
  return (
    <Router>
      <Switch>
        <Route exact path='/' component={Land1}></Route>
      </Switch>
  </Router>
  );
}

export default App;
